'use strict';

const TaskAPI = require('communication/infra/api/task/index');
const TaskRepository = require('communication/domain/repository/task');
const TaskFactory = require('communication/domain/factory/task');
const CommentFactory = require('communication/domain/factory/comment');
const CommentRepository = require('communication/domain/repository/comment');

class Service {
    constructor(project, taskID, commentJSON) {
        this._project = project;
        this._taskID = taskID;
        this._commentJSON = commentJSON;
    }

    replyComment() {
        return TaskAPI.replyComment(this._project.id, this._taskID, this._commentJSON)
            .then(json => {
                const taskJSON = json.task;
                const commentJSON = json.comment;

                return Promise.all([
                    new CommentFactory(this._project).build(commentJSON),
                    new TaskFactory(this._project).build(taskJSON)
                ]);
            })
            .then(values => {
                const comment = values[0];
                const task = values[1];

                CommentRepository.find(this._project).add(comment);
                TaskRepository.find(this._project).add(task);

                return task;
            });
    }
}

module.exports = Service;



// WEBPACK FOOTER //
// ./communication/app/service/task/reply-comment.js